import React from 'react';
import styles from './Toggle.module.css';

class Toggle extends React.Component {
  render() {
    const { checked, onChange, label, description, size = 'md', disabled = false } = this.props;

    const pillCls = [
      styles.pill,
      styles[size],
      checked ? styles.on : '',
      disabled ? styles.disabled : '',
    ].filter(Boolean).join(' ');

    return (
      <div className={styles.row}>
        {(label || description) && (
          <div className={styles.info}>
            {label      && <div className={styles.label}>{label}</div>}
            {description && <div className={styles.desc}>{description}</div>}
          </div>
        )}
        {/* Every caller (CampaignWizard's delivery settings, SaveSegmentBar)
            passes onChange={v => ...} expecting the new boolean value — this
            used to hand the raw click SyntheticEvent to that callback instead
            (and read a nonexistent `on` prop, so the pill also never visually
            reflected real state), so every toggle silently did nothing useful. */}
        <div className={pillCls} onClick={disabled ? undefined : () => onChange(!checked)} />
      </div>
    );
  }
}

export default Toggle;
